/* globals __CLIENT__ */

import React, { PropTypes, PureComponent } from 'react';

import authService from '../../state/services/auth';
import trackingService from '../../state/services/tracking';

import LoginPromptBanner from './Banner';

class LoginPromptOverlayContainer extends PureComponent {
  render() {
    // If the user has ever registered - do not show the login prompt
    if (authService.getUserCookie() || this.props.noBanner || !__CLIENT__) {
      return null;
    }

    trackingService.trackEvent('Login Banner Appeared');

    return (
      <LoginPromptBanner
        {...this.props}
      />
    );
  }
}

export default LoginPromptOverlayContainer;

LoginPromptOverlayContainer.propTypes = {
  /**
   * Whether the banner should be invisible
   */
  noBanner: PropTypes.bool,
};

LoginPromptOverlayContainer.defaultProps = {
  noBanner: false,
};



// WEBPACK FOOTER //
// ./app/src/components/LoginPrompt/container.jsx